import React from 'react'
import ReactDOM from 'react-dom'
import EntitySelector from 'analytics/component/EntitySelector'
import styled from 'styled-components'
import { getPeriod, getLoading, getShowSelector, getYear } from '../selectors'
import { connect } from 'react-redux'
import { hideSelector, changePeriod, setYear } from '../actions'

const Container = styled.div`
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10vh 20vw;
  overflow: auto;
  z-index: 900;
`

const EntitySelectorOverLay = ({ selectorVisible, hideSelector, ...rest }) =>
  selectorVisible && (
    <Container>
      <EntitySelector hide={hideSelector} {...rest} />
    </Container>
  )

//
const mapStateToProps = state => ({
  period: getPeriod(state),
  loading: getLoading(state),
  selectorVisible: getShowSelector(state),
  year: getYear(state),
})

export default connect(mapStateToProps, { hideSelector, changePeriod, setYear })(
  EntitySelectorOverLay
)
